import Vue from "vue";
import VueRouter from "vue-router";
import home from '@/view/home/home'
import store from '@/store'
Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        component: home,
        meta: {
            title: "GIC"
        },
        children: [
            {
                path: "/",
                component: resolve => require(["@/view/home/index.vue"], resolve),
                meta: {
                    title: "GIC"
                }
            },
            {

                path: "/links",
                component: resolve => require(["@/view/link/index.vue"], resolve),
                meta: {
                    title: "联系我们"
                }
            },
            {

                path: "/rangeDetail",
                component: resolve => require(["@/view/rangeDetail/index.vue"], resolve),
                meta: {
                    title: "检测流程及范围"
                }
            },
            {
                path: "/instrument",
                component: resolve => require(["@/view/instrument/index.vue"], resolve),
                meta: {
                    title: "检测仪器与方法"
                }
            },
            {
                path: "/article/:articleId",
                component: resolve => require(["@/view/article/index.vue"], resolve),
            },
            // {
            //     path: "/message",
            //     component: resolve => require(["@/view/message/index.vue"], resolve),
            //     meta: {
            //         title: "留言板"
            //     }
            // },
            {
                path: "/about",
                component: resolve => require(["@/view/about/index.vue"], resolve),
                meta: {
                    title: "关于我们"
                }
            },
            // {
            //     path: "/certificate",
            //     component: resolve => require(["@/view/certificate/index.vue"], resolve),
            //     meta: {
            //         title: "证书查询"
            //     }
            // },
            {
                path: "/newposts",
                component: resolve => require(["@/view/article/Add"], resolve),
            },
            {
                path: "/archive",
                component: resolve => require(["@/view/archive/index"], resolve),
                meta: {
                    title: "文章归档"
                }
            },
            {
                path: "/category",
                component: resolve => require(["@/view/category/index.vue"], resolve),
                meta: {
                    title: "文章分类"
                }
            },
            {
                path: "/notice/:id",
                component: resolve => require(["@/view/notice/index.vue"], resolve),
                meta: {
                    title: "收费相关"
                }
            },
            {
                path: "/message",
                component: resolve => require(["@/view/message/index.vue"], resolve),
                meta: {
                    title: "声明"
                }
            },

            {
                path: "/tags",
                component: resolve => require(["@/view/tag/index"], resolve),
                meta: {
                    title: "文章标签"
                }
            },
            {
                path: "/say",
                component: resolve => require(["@/view/say/index"], resolve),
                meta: {
                    title: "说说"
                }
            },
            {
                path: "/newSays",
                component: resolve => require(["@/view/say/Add"], resolve),
                meta: {
                    title: "添加说说"
                }
            },
            {
                path: "/im",
                component: resolve => require(["@/view/im/index"], resolve),
                meta: {
                    title: "GIC"
                }
            },
            {
                 title: "网站热搜",
                path: "/hot",
                component: resolve => require(["@/view/search/Hot.vue"], resolve),
                meta: {
                    title: "网站热搜"
                }
            },
            {
                name: "notice",
                path: "/notice/id",
                component: resolve => require(["@/view/notice/index.vue"], resolve),
                meta: {
                    title: "GIC"
                }
            },
            {
                path: "/navigation",
                component: resolve => require(["@/view/navigation/index.vue"], resolve),
                meta: {
                    title: "网站导航"
                }
            },
            {
                path: "/user",
                component: resolve => require(["@/view/user/index.vue"], resolve),
                meta: {
                    title: "GIC"
                }
            },
            {
                path: "/about-gic",
                component: resolve => require(["@/view/about-gic/index.vue"], resolve),
                meta: {
                    title: "关于GIC"
                }
            },
            {
                path: "/contact-us",
                component: resolve => require(["@/view/contact-us/index.vue"], resolve),
                meta: {
                    title: "联系我们"
                }
            },
            {
                path: "/experts",
                component: resolve => require(["@/view/experts/index.vue"], resolve),
                meta: {
                    title: "专家介绍"
                }
            },
            {
                path: "/certificate-check",
                component: resolve => require(["@/view/certificate/index.vue"], resolve),
                meta: {
                    title: "证书查询"
                }
            },
            {
                path: "/statement",
                component: resolve => require(["@/view/message/index.vue"], resolve),
                meta: {
                    title: "公正性声明"
                }
            },
            {
                path: "/join-us",
                component: resolve => require(["@/view/join-us/index.vue"], resolve),
                meta: {
                    title: "加入我们"
                }
            },
            {
                path: "/surrounding",
                component: resolve => require(["@/view/surrounding/index.vue"], resolve),
                meta: {
                    title: "品牌周边"
                }
            },
            {
                path: "/gem",
                component: resolve => require(["@/view/gem/index.vue"], resolve),
                meta: {
                    title: "宝石百科"
                }
            },
            {
                path: "/question",
                component: resolve => require(["@/view/question/index.vue"], resolve),
                meta: {
                    title: "常见问题"
                }
            }
        ],
    },
    {
        path: "*",
        name: "NotFound",
        component: () => import("@/view/404/404.vue"),
    }
];

const router = new VueRouter({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: "smooth"
            };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes
});
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
    store.state.searchDialogVisible = false;
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
export default router;